import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import 'amfe-flexible'
import VueClipboard from 'vue-clipboard2'
import vEmits from "@/utils/vEmits"
import reLogin from "@/utils/reLogin";



import './utils/vantuse'
import './utils/comptuse'
// import Vconsole from 'vconsole';
// new Vconsole();

Vue.config.productionTip = false;

Vue.prototype.push = function(pushDat){
    vEmits.$emit('rNext');
    this.$router.push(pushDat);
}

Vue.prototype.go = function(goDat){
    let path = this.$router.currentRoute.path;
    if(path == '/'){
        return;
    }
    this.$router.go(goDat);
}

Vue.directive('title', {
    inserted: function (el) {
        document.title = el.dataset.title
    }
})



Vue.use(VueClipboard);

reLogin();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
